<template>
    <div class="col-12 col-md-6 col-lg-4">
        <b-card
            class="skills-card apprentice-simple-card-with-banner"
            no-body>
            <b-card-img
                class="skills-card-banner banner"
                :src="routes.baseUrl() + '/images/britannica/britannica-image-banner.jpg'"
                top></b-card-img>
            <b-card-body body-class="skills-card-body body">
                <div class="muted-text">
                    <p>
                        {{
                            $t(
                                'britannica.find_right_free_images_that_match_your_paper_or_assignment_you_can_download_the_images_and_use_them_for_school_assignments',
                            )
                        }}
                    </p>
                </div>
            </b-card-body>
            <b-card-footer>
                <b-button
                    variant="primary"
                    :href="this.routes.baseUrl() + '/britannica/' + schoolIdIn + '/quest'"
                    target="_blank"
                    >{{ $t('britannica.start') }}</b-button
                >
            </b-card-footer>
        </b-card>
    </div>
</template>

<script>
export default {
    name: 'design-2021-britannica-image-quest-component',
    props: ['schoolIdIn'],
};
</script>

<style scoped lang="scss">
.card-footer {
    background-color: transparent;
    border-top: none;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
